import React from 'react';
import { FadeIn } from './FadeIn';
import { ButtonCTA } from './ButtonCTA';
export function Hero() {
  return <section className="relative bg-navy text-parchment overflow-hidden pt-20 pb-24 md:pt-32 md:pb-32 border-b-4 border-gold/60" data-id="element-113">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-10 bg-texture" data-id="element-114"></div>

      {/* Subtle radial gradient for depth */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(42,64,110,0.5)_0%,transparent_100%)]" data-id="element-115"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-116">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-117">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-118">
            <FadeIn data-id="element-119">
              <div className="inline-block mb-4 px-4 py-1.5 border border-gold/30 rounded-full bg-navy-dark/50 backdrop-blur-sm" data-id="element-120">
                <span className="text-gold font-serif text-sm tracking-widest uppercase" data-id="element-121">
                  El Código de Habacuc
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-122">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white text-balance" data-id="element-123">
                Deja de mendigar provisiones y empieza a{' '}
                <span className="text-gold italic" data-id="element-124">escribir tu abundancia</span>
                .
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-125">
              <h2 className="text-lg md:text-xl lg:text-2xl text-parchment/80 mb-10 font-body leading-relaxed text-balance" data-id="element-126">
                El sistema bíblico de 3 pasos para activar las leyes de
                suministro inagotable y manifestar libertad financiera en tiempo
                récord.
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} className="flex flex-col items-center lg:items-start" data-id="element-127">
              <ButtonCTA onClick={() => document.getElementById('offer')?.scrollIntoView()} data-id="element-128" />
              <p className="mt-4 text-sm text-parchment/60 font-body italic" data-id="element-129">
                Acceso inmediato • Pago 100% seguro
              </p>
            </FadeIn>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-md lg:max-w-none" data-id="element-130">
            <FadeIn delay={0.4} direction="left" data-id="element-131">
              <div className="relative" data-id="element-132">
                {/* Decorative frame */}
                <div className="absolute -inset-4 border-2 border-gold/20 rounded-lg transform rotate-3 transition-transform hover:rotate-0 duration-500" data-id="element-133"></div>
                <div className="absolute -inset-4 border-2 border-gold/20 rounded-lg transform -rotate-2 transition-transform hover:rotate-0 duration-500" data-id="element-134"></div>

                <div className="relative rounded-lg overflow-hidden shadow-2xl shadow-black/50 border border-gold/30" data-id="element-135">
                  <img src="https://cdn.magicpatterns.com/uploads/dRMTL1DQV9CYMpYCvUK1fx/heylloyd-image-1774727674851_HABACUC.png" alt="El Código de Habacuc en una tablet sobre un escritorio con una Biblia" className="w-full h-auto object-cover" data-id="element-136" />
                  {/* Overlay gradient to blend image slightly */}
                  <div className="absolute inset-0 bg-gradient-to-t from-navy/40 to-transparent mix-blend-multiply" data-id="element-137"></div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}